import { Location } from '@bringg/types';
import { GoogleTravelMode } from '../types/shared-location.types';
class DirectionService {
	async getRoute(
		origin: Location,
		destination: Location,
		travelMode: GoogleTravelMode
	): Promise<google.maps.LatLng[]> {
		return new Promise<google.maps.LatLng[]>((resolve, reject) => {
			const DirectionsService = new google.maps.DirectionsService();
			DirectionsService.route(
				{
					origin: new google.maps.LatLng(origin.lat, origin.lng),
					destination: new google.maps.LatLng(destination.lat, destination.lng),
					travelMode: travelMode as unknown as google.maps.TravelMode
				},
				(result, status) => {
					if (status === google.maps.DirectionsStatus.OK) {
						const [path] = result.routes;
						resolve(path.overview_path);
					} else {
						reject();
					}
				}
			);
		});
	}
}

export default DirectionService;
